import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface DeletePortInfoFilePayload {
  fileId: string
  portInfoId: string
}

export function useDeletePortInfoFile() {
  const fetchRequest = useFetch<{ ok: string }>()

  return useMutation({
    mutationFn: async ({ fileId }: DeletePortInfoFilePayload) => {
      const response = await fetchRequest(
        `${apiBase()}/files/${fileId}`,
        undefined,
        undefined,
        'DELETE',
      )

      return response
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/portinfo', variables.portInfoId],
      })
    },
  })
}
